import { render, staticRenderFns } from "./service-cell.vue?vue&type=template&id=747c3b43&scoped=true&"
import script from "./service-cell.vue?vue&type=script&lang=js&"
export * from "./service-cell.vue?vue&type=script&lang=js&"
import style0 from "./service-cell.vue?vue&type=style&index=0&id=747c3b43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c3b43",
  null
  
)

export default component.exports